import { render, staticRenderFns } from "./IcpLink.vue?vue&type=template&id=37751026&scoped=true"
import script from "./IcpLink.vue?vue&type=script&lang=js"
export * from "./IcpLink.vue?vue&type=script&lang=js"
import style0 from "./IcpLink.vue?vue&type=style&index=0&id=37751026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37751026",
  null
  
)

export default component.exports